<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { useBranchesList } from '@/models/branch'
  import { useAuthStore } from '@/stores/auth'

  defineProps<{
    label?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()
  const authStore = useAuthStore()

  const { branches, loading, getData } = useBranchesList()
  const filteredBranches = computed(() =>
    branches.value.filter(branch => branch.id !== authStore.user.branch?.id),
  )
  getData()

  const selectedBranch = computed({
    set: (branch?: string) => updateRoute({ branch }),
    get: () => route.query.branch as string | undefined,
  })
</script>

<template>
  <app-select
    v-model="selectedBranch"
    :label="label ?? 'Cabang'"
    :loading="loading">
    <option :value="undefined">
      Semua
    </option>
    <option
      v-for="branch in filteredBranches"
      :key="branch.id"
      :value="branch.id">
      {{ branch.code }}
    </option>
  </app-select>
</template>
